import React from "react";

function PendingRequest() {
  return <div>PendingRequest</div>;
}

export default PendingRequest;
